import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselComponent } from './carousel.component';
import { TranslocoModule } from '@jsverse/transloco';
// import { MdbCarouselModule } from 'mdb-angular-ui-kit/carousel';
import { CarouselModule } from 'ngx-bootstrap/carousel';



@NgModule({
  declarations: [CarouselComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    // MdbCarouselModule,
    CarouselModule,
  ],
  exports:[
    CarouselComponent
  ]
})
export class CarouselBasicModule { }
